/*eslint no-unused-vars: "error"*/

import "../../css/pages/industriesDetail.scss";
import Tabs from "../modules/tabs";
import sectionNav from "../modules/sectionNav";

import BasePage from "./base";
import PageHero from "../modules/pageHero";
import smartGrid from "../modules/smartGrid";

import smartNewList from "../modules/smartNewsList";
import background from "../modules/background";

class IndustriesDetailPage extends BasePage {
    scrolledHash() {
        let anchorHash = window.location.hash;

        if (anchorHash !== null || anchorHash !== "") {
            anchorHash = anchorHash.replace("#", "");
            let anchor = document.getElementById(anchorHash);

            let headerHeight = document.querySelector("header .nav").offsetHeight;
            if (anchor) {
                let elementPosition = anchor.getBoundingClientRect().top;
                let offsetPosition = elementPosition - headerHeight;
                window.scrollBy({
                    top: offsetPosition,
                    behavior: "smooth"
                });
            }
        }
    }

    constructor(...opts) {
        super(...opts);
    }

    init() {
        super.init();
        new Tabs();
        new PageHero();
    }

    onReady() {
        super.onReady();
        sectionNav.init();
        smartGrid.init();
        this.scrolledHash();
        smartNewList.init();
        background.init();
    }
}

new IndustriesDetailPage();
